import { render } from "./ModalPrivacy.vue?vue&type=template&id=518f0064&scoped=true"
import script from "./ModalPrivacy.vue?vue&type=script&lang=js"
export * from "./ModalPrivacy.vue?vue&type=script&lang=js"

import "./ModalPrivacy.vue?vue&type=style&index=0&id=518f0064&scoped=true&lang=css"

import exportComponent from "/Users/geoffsargison/Documents/laravel-valet/ces-calculator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-518f0064"]])

export default __exports__